import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import customParseFormat from 'dayjs/plugin/customParseFormat'
// import { checker } from '@/utils/updateChecker'
import { isServe, isBuild, isProd, showVconsole } from '@/env'
import '@/scripts'
// import '@/utils/webpush'
import '@/hooks/useTrack'
import '@/hooks/usePWA'
import '@/app'
import '@/assets/main.scss'
import 'virtual:svg-icons-register'
import initVconsole from '@/utils/initVconsole'

if (isServe || (isBuild && !isProd) || showVconsole) {
  initVconsole()
}

dayjs.extend(utc)
dayjs.extend(timezone) // 使用时区插件
dayjs.extend(weekOfYear)
dayjs.extend(customParseFormat)
